<template>
  <div class="container-fluid">
    <table class="xz-table">
      <tbody>
      <tr>
        <td class="xz-various-counters-label">Kasseskuffåpninger:</td>
        <td colSpan="2">{{zReport.cashBoxOpeningsCount}}x</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Salgskvitteringer:</td>
        <td colSpan="2">{{zReport.saleReceiptsCount}}x</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Kopikvitteringer:</td>
        <td class="xz-various-counters-width">{{ zReport.copyReceiptsCount }}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(zReport.copyReceiptsTotalAmount) }}</td>
      </tr>
      <!-- How many returns there were, as «Salgskvitteringer» is how many sales: «Total refusjon» counts the payments
           paid back (founder, 2026-10-29). -->
      <tr>
        <td class="xz-various-counters-label">Returkvitteringer:</td>
        <td class="xz-various-counters-width">{{ zReport.refundReceiptsCount || 0 }}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(zReport.refundReceiptsTotalAmount || 0) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Rabatter:</td>
        <td class="xz-various-counters-width">{{ zReport.discountsCount }}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(zReport.discountsTotalAmount) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Avbrutte salg:</td>
        <td class="xz-various-counters-width">{{zReport.uncompletedSalesCount}}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(zReport.uncompletedSalesTotalAmount) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
    <table class="xz-table">
      <tbody>
      <tr>
        <td class="xz-various-counters-label">Grand total salg:</td>
        <td colSpan="2">{{ displayTwoDecimals(zReport.grandTotalSales) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Grand total retur:</td>
        <td colSpan="2">{{ displayTwoDecimals(zReport.grandTotalRefund) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Grand total netto:</td>
        <td colSpan="2">{{ displayTwoDecimals(grandTotalNet) }}</td>
      </tr>
      </tbody>
    </table>
    <div v-if="zReport.dayStartedCashAmount != null || zReport.dayEndedCashAmount != null">
      <hr class="horizontal-dashed"/>
      <table class="xz-table">
        <tbody>
        <tr v-if="zReport.dayStartedCashAmount != null">
          <td class="xz-various-counters-label">Kontanter ved dagsstart:</td>
          <td colSpan="2">{{ displayTwoDecimals(zReport.dayStartedCashAmount) }}</td>
        </tr>
        <tr v-if="zReport.dayEndedCashAmount != null">
          <td class="xz-various-counters-label">Kontanter ved dagsslutt:</td>
          <td colSpan="2">{{ displayTwoDecimals(zReport.dayEndedCashAmount) }}</td>
        </tr>
        <tr v-if="zReport.cashWithdrawalAmount != null && zReport.cashWithdrawalAmount != 0">
          <td class="xz-various-counters-label">Kontantuttak:</td>
          <td colSpan="2">{{ displayTwoDecimals(zReport.cashWithdrawalAmount) }}</td>
        </tr>
        <tr v-if="zReport.cashWithdrawalReason">
          <td class="xz-various-counters-label">Grunn for uttak:</td>
          <td colSpan="2">{{ zReport.cashWithdrawalReason }}</td>
        </tr>
        <tr v-if="zReport.diff != null && zReport.diff != 0">
          <td class="xz-various-counters-label">Avvik:</td>
          <td colSpan="2">{{ displayTwoDecimals(zReport.diff) }}</td>
        </tr>
        <tr v-if="zReport.comment">
          <td class="xz-various-counters-label">Kommentar:</td>
          <td colSpan="2">{{ zReport.comment }}</td>
        </tr>
        </tbody>
      </table>
      <div v-if="zReport.dayEndedBy">
        <hr class="horizontal-dashed"/>
        <table class="xz-table">
          <tbody>
          <tr>
            <td class="xz-various-counters-label">Dagsoppgjør utført av:</td>
            <td colSpan="2">{{ zReport.dayEndedBy }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      zReport: Object
    },
    computed: {
      grandTotalNet() {
        return (this.zReport.grandTotalSales - this.zReport.grandTotalRefund);
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
